// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Franquias_SalvarOperacionalResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /franquias/salvarOperacional/{franquia_id}
 *
 * Returns the saved configuracao_franquia row after persisting the operational
 * fields — same single-object shape as /franquias/dashboard/{id} and
 * /franquias/salvarMetas/{id}. The controller calls
 * Configuracao_franquia_model::salvar(), which returns getPorFranquia() (a
 * single Configuracao_franquia_record DB row).
 *
 * @see Franquias::salvarOperacional()
 * @see Configuracao_franquia_model::salvar()
 */
import type { Franquias_ConfiguracaoFranquiaRow } from './Franquias_ConfiguracaoFranquiaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Franquias_SalvarOperacionalResponseDados = Franquias_ConfiguracaoFranquiaRow;

export type Franquias_SalvarOperacionalResponse = ApiResponse<Franquias_SalvarOperacionalResponseDados>;

registerResponseContract('Franquias_SalvarOperacionalResponse', {
  franquia_id:                { type: 'number',  required: false },
  abre_sabado:                { type: 'number',  required: false },
  abre_domingo:               { type: 'number',  required: false },
  dias_uteis_padrao:          { type: 'number',  required: false },
  investimento_total:         { type: 'string',  required: false },
  roe_desejado:               { type: 'string',  required: false },
  capacidade_producao_diaria: { type: 'number',  required: false },
  meta_producao_itens_dia:    { type: 'number',  required: false },
  meta_contatos_retomada_dia: { type: 'number',  required: false },
  valor_medio_item:           { type: 'string',  required: false },
  meta_faturamento_mensal:    { type: 'string',  required: false },
  meta_faturamento_anual:     { type: 'string',  required: false },
  mensagem_aniversariante:    { type: 'string',  required: false },
  mensagem_boas_vindas:       { type: 'string',  required: false },
  nome_fantasia:              { type: 'string',  required: false },
  telefone:                   { type: 'string',  required: false },
  inaugurado_em:              { type: 'string',  required: false },
  cnpj:                       { type: 'string',  required: false },
  inscricao_estadual:         { type: 'string',  required: false },
  endereco:                   { type: 'string',  required: false },
  numero:                     { type: 'string',  required: false },
  complemento:                { type: 'string',  required: false },
  bairro:                     { type: 'string',  required: false },
  cidade:                     { type: 'string',  required: false },
  estado:                     { type: 'string',  required: false },
  cep:                        { type: 'string',  required: false },
})
